export enum ELieuPrelevementAir {
    // MilieuSalle = 1,
    Autre = 2
}